var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "x_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5215",
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "close",
  clipPath: "url(#x_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13258",
  d: "M19.705 18.247 11.414 10l8.251-8.292A1 1 0 1 0 18.247.295L10 8.586 1.705.334A1 1 0 0 0 .3 1.752L8.585 10 .334 18.294a1 1 0 0 0 1.419 1.411L10 11.414l8.3 8.251a1 1 0 0 0 1.41-1.418",
  fill: "currentColor"
}))));
export default SvgX;